import { drawerEdgeResizePlugin } from './drawerEdgeResizePlugin.js';
import { panelDrawerWidthStorage } from '@/ui/adapters/drawerWidth';

export const PANEL_SITE_SIDEBAR_WIDTH_STORAGE_KEY = 'solvit-panel-site-sidebar-width';
export const PANEL_SITE_SIDEBAR_DEFAULT_WIDTH = 240;
export const PANEL_SITE_SIDEBAR_MIN_WIDTH = 200;
export const PANEL_SITE_SIDEBAR_MAX_WIDTH = 480;

export function clampPanelSiteSidebarWidth(width) {
  if (
    typeof width === 'number' &&
    !Number.isNaN(width) &&
    width >= PANEL_SITE_SIDEBAR_MIN_WIDTH &&
    width <= PANEL_SITE_SIDEBAR_MAX_WIDTH
  ) {
    return width;
  }
  return PANEL_SITE_SIDEBAR_DEFAULT_WIDTH;
}

export async function readPanelSiteSidebarWidth() {
  try {
    const saved = await panelDrawerWidthStorage.get(PANEL_SITE_SIDEBAR_WIDTH_STORAGE_KEY);
    return clampPanelSiteSidebarWidth(saved);
  } catch {
    return PANEL_SITE_SIDEBAR_DEFAULT_WIDTH;
  }
}

/**
 * 패널 플래닝 — 사이트 목록 사이드바 width 리사이즈
 */
export const panelSiteSidebarResizePlugin = {
  id: 'panel-site-sidebar-resize',

  attach(containerEl, ctx = {}) {
    return drawerEdgeResizePlugin.attach(containerEl, {
      edge: 'right',
      minWidth: PANEL_SITE_SIDEBAR_MIN_WIDTH,
      maxWidth: PANEL_SITE_SIDEBAR_MAX_WIDTH,
      storageKey: PANEL_SITE_SIDEBAR_WIDTH_STORAGE_KEY,
      storage: panelDrawerWidthStorage,
      handleClass: 'drawer-edge-resize-handle panel-site-sidebar-resize-handle',
      ...ctx
    });
  }
};
